export const inputs = [
    {
        columns: [
            {
                type: "checkbox",
                id: "showAsAdmin",
                name: "showAsAdmin",
                label: "U komentarima i na forumu označi me kao Administratora",
                required: false,
            },
        ],
    },
];
